export function addCarousel(el) {

  if(!el) {
    return
  }

  const carousel = document.querySelector('.product_ingredients-carousel')
  const controls = Array.from(carousel.querySelectorAll('.controls'))
	const items = Array.from(carousel.querySelectorAll('.carousel-item'))
  const carouselWrapper = carousel.querySelector('.carousel-items')
	const prev = carousel.querySelector('.controls__prev')
	const next = carousel.querySelector('.controls__next')


  const perPage = 5

  if(!items.length) {
    carousel.style.display = 'none'
    return
  }

  prev.addEventListener('click', ()=> {
    if (position === 0) {
      return
    }
    position--
    setPosition(position)
  })

  next.addEventListener('click', ()=> {

    if (position === items.length - perPage) {
      return
    }
    position++
    setPosition(position)
  })

	let position = 0,
      itemWidth = 0


  let setItemSize = ()=> {
    let itemStyle = window.getComputedStyle(items[0])
    itemWidth = parseInt(itemStyle.width) + parseInt(itemStyle.marginLeft) + parseInt(itemStyle.marginRight)
    carouselWrapper.style.width = itemWidth*items.length+1
  }

	const setPosition = (position)=> {
    carouselWrapper.style.transform = `translateX(${ position * itemWidth * -1 }px)`
    setButtonState(position)
  }

  const setButtonState = (position) => {
    prev.classList.remove('disabled')
    next.classList.remove('disabled')

    if (position === 0) {
      prev.classList.add('disabled')
    }
    if (position === items.length - perPage) {
      next.classList.add('disabled')
    }
  }

  setItemSize()
  setPosition(0)

  if(items.length < 4) {
    carouselWrapper.classList.add('center-wrap')
  } else if (items.length<perPage && items.length > 3) {
    controls.forEach((e) => {
      e.classList.add('hidden')
    })
    carouselWrapper.classList.remove('center-wrap')
  } else {
      if(window.innerWidth > 769) {
        carouselWrapper.style.minWidth = '1870px'
      }
    carouselWrapper.style.justifyContent = 'flex-start'
    carouselWrapper.classList.remove('center-wrap')
  }

  window.addEventListener('resize', setItemSize, false);

}



// WEBPACK FOOTER //
// ./src/carousel.js